import * as React from 'react';
import {Field} from 'formik';

const CoisViewFileds = (props) => {
    return (
        <ul className="details">
            <li>
                <label>{props.filedetName}</label>
            </li>
            {props.values.map(((value, i) => {
                return (
                <li key={i}>
                    <div
                         className={"text-field primary" + (props.err[props.keys[i]] ? ' invalid' : '')}>
                        <label htmlFor="" className="label">{props.keys[i]}:</label>
                        <div className="content">
                            <Field type="text" value={value} name={props.keys[i]}/>
                        </div>
                    </div>
                </li>)
            }))}

        </ul>
    );
};

export default CoisViewFileds;


// WEBPACK FOOTER //
// ./src/components/Cois/CoisViewFields.tsx